import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './Layout'
import Dashboard from './Dashboard'
import GmbManager from './GmbManager'
import Subscription from './subscription'
import Action from './Action'
import ReviewList from './ReviewList'
import Paymenthistory from '../whatsapp/small_component/biling/paymenthistory'
import ReferralPage from './ReferralPage'
import Documentation from './Documentation'

function Routing() {
  return (
    <Routes>
        <Route element={<Layout/>} >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path='/dashboard' element={<Dashboard/>}/>
            <Route path='/manage_gmb' element={<GmbManager/>}/>
            <Route path='/subscription' element={<Subscription/>}/>
            <Route path='/action/:storeCode' element={<Action/>}/>
            <Route path='/review' element={<ReviewList/>}/>
            <Route path='/payment-history' element={<Paymenthistory product="gmb"/>}/>
            <Route path='/refer_earn' element={<ReferralPage product="gmb"/>}/>
             <Route path='/documentation' element={<Documentation/>}/>
        </Route>
    </Routes>
  )
}

export default Routing
